import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="w-full px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-vip-diamond-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-semibold text-foreground-950">
                美女网站
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-7 text-foreground-600">
              精选美女图片、写真集展示及相关娱乐资讯分享平台，致力于为喜爱视觉艺术的朋友提供高品质的浏览与收藏体验。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700">
                <i className="ri-mail-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">快速导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li>
                <Link to="/gallery" className="transition-colors hover:text-primary-600">
                  图片分类
                </Link>
              </li>
              <li>
                <Link to="/photobooks" className="transition-colors hover:text-primary-600">
                  写真专题
                </Link>
              </li>
              <li>
                <Link to="/news" className="transition-colors hover:text-primary-600">
                  娱乐资讯
                </Link>
              </li>
              <li>
                <Link to="/favorites" className="transition-colors hover:text-primary-600">
                  我的收藏
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">联系我们</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-primary-500"></i>
                hello@meinv-site.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base text-primary-500"></i>
                400-888-0123
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-600">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 美女网站 · 精选美女图片与娱乐内容分享平台 版权所有</p>
          <p>本网站图片与资讯均为演示示例，仅供学习交流使用</p>
        </div>
      </div>
    </footer>
  );
}